import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, inject, ChangeDetectionStrategy, signal, input, OnChanges, SimpleChanges } from '@angular/core';
import {Router} from '@angular/router';
import {PersonLogin} from '../person/person-login';
import {SelectionItem} from '../selections/selection-item';
import {IecTaskService} from '../services/iec-task-service';
import {PersonLoginService} from '../services/person-login-service';
import {SelectionService} from '../services/selection-service';
import {TaskResponseService} from '../services/task-response-service';
import {StringUtils} from '../utils/string-utils';
import {IecTask} from './iec-task';
import {OrderCancelTaskResponse} from './order-cancel-task-response';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { FormsModule } from '@angular/forms';



@Component({
    selector: 'cancellation-request-task',
    templateUrl: './cancellation-request-task.component.html',
    styleUrls: ['./cancellation-request-task.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, MatButton, MatIcon, MatProgressSpinner]
})
export class CancellationRequestTaskComponent implements OnInit, OnChanges {
  readonly taskId = input.required<string>({ alias: 'task-id' });
  private readonly personLoginService = inject(PersonLoginService);
  private readonly taskResponseService = inject(TaskResponseService);
  private readonly iecTaskService = inject(IecTaskService);
  private readonly selectionService = inject(SelectionService);
  private readonly router = inject(Router);


  private personLogin!: PersonLogin;
  readonly cancelReasons = signal<SelectionItem[]>(undefined!);
  readonly task = signal<IecTask>(undefined!);
  response!: OrderCancelTaskResponse;
  readonly isBusy = signal<boolean>(false);
  readonly errorMessage = signal<string>(undefined!);

  ngOnInit(): void {
    if (this.personLoginService.isOutsideEngineer()) {
      this.router.navigate(['ratings']);
    } else {
      this.response = new OrderCancelTaskResponse();
      this.personLogin = this.personLoginService.getCachedLogin()!;
      this.selectionService.getCancelReasons("CONTRACT").subscribe(response => {
        this.cancelReasons.set(response);
      }, error => this.handleError(error));
      this.loadTask();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['taskId'].firstChange) {
      this.loadTask();
    }
  }

  private loadTask(): void {
    const taskIdString: string = this.taskId();
    if (taskIdString && !isNaN(+taskIdString) && +taskIdString > 0) {
      this.iecTaskService.getTask(+taskIdString).subscribe(result => this.task.set(result), error => this.handleError(error));
    } else {
      this.router.navigate(['main']);
    }
  }

  saveResponse(): void {
    this.isBusy.set(true);
    this.taskResponseService.orderCancel(this.task().id, this.response).subscribe(() => this.router.navigate(['main']), error => this.handleError(error));
  }

  private handleError(error: HttpErrorResponse) {
    this.isBusy.set(false);
    this.errorMessage.set(StringUtils.getErrorMessage(error));
  }

}
